import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { registerLocaleData, APP_BASE_HREF } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';

// i18n support
import localeIt from '@angular/common/locales/it';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './/app-routing.module';
import { LayoutComponent } from './components/layout/layout.component';
import { HeaderComponent } from './components/header/header.component';
import { SupportComponent } from './pages/support/support.component';
import { CategoryComponent } from './pages/category/category.component';
import { SearchComponent } from './pages/search/search.component';
import { ErrorNotificationService } from '../../../admin/src/app/services/error-notification.service';
import { UrlSerializer, DefaultUrlSerializer } from '@angular/router';
import { SearchQuerySerializer } from './services/search-query.serializer';
import { ProductComponent } from './pages/product/product.component';
import { ProductInformationComponent } from './pages/product/product-information/product-information.component';
import { ProductManualComponent } from './pages/product/product-manual/product-manual.component';
import { ProductFaqsComponent } from './pages/product/product-faqs/product-faqs.component';
import { ProductTechnicalSheetComponent } from './pages/product/product-technical-sheet/product-technical-sheet.component';
import { ProductMediaComponent } from './pages/product/product-media/product-media.component';
import { ProductSoftwareComponent } from './pages/product/product-software/product-software.component';
import { FaqComponent } from './pages/faq/faq.component';
import { BlankComponent } from './pages/blank/blank.component';
import { LoginComponent } from './pages/login/login.component';
import { RegisterComponent } from './pages/register/register.component';
import { RoutingStateService } from './services/routing-state.service';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';
import { DropdownComponent } from '../../../admin/src/app/components/dropdown/dropdown.component';
import { TicketComponent } from './pages/ticket/ticket.component';
import { LocalizedTextPipe } from './pipes/localized-text.pipe';
import { BlockCopyPasteDirective } from './directives/block-copy-paste.directive';
import { NgcCookieConsentConfig, NgcCookieConsentModule } from 'ngx-cookieconsent';
import { environment } from 'projects/frontend/src/environments/environment';
import { ArticleComponent } from './pages/article/article.component';
import { ProductKBComponent } from './pages/product/product-kb/product-kb.component';
import { ProductVideosComponent } from './pages/product/product-videos/product-videos.component';
import { MatomoModule } from 'ngx-matomo';
import { DeleteAccountComponent } from './pages/delete-account/delete-account.component';

// i18n support
export function createTranslateLoader(http: HttpClient, baseHref) {
  // Temporary Azure hack
  if (baseHref == null && typeof window !== 'undefined') {
    baseHref = window.location.origin;
  }
  if (baseHref == null) {
    baseHref = '';
  }
  // i18n files are in `wwwroot/assets/`
  return new TranslateHttpLoader(http, `${baseHref}/assets/i18n/`, '.json');
}

registerLocaleData(localeIt, 'it');

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: environment.domain
  },
  palette: {
    popup: {
      background: '#000'
    },
    button: {
      background: '#f1d600'
    }
  },
  theme: 'edgeless',
  type: 'opt-out'
};

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    HeaderComponent,
    DropdownComponent,
    BlankComponent,
    LoginComponent,
    RegisterComponent,
    SupportComponent,
    CategoryComponent,
    ProductComponent,
    ProductInformationComponent,
    ProductManualComponent,
    ProductFaqsComponent,
    ProductTechnicalSheetComponent,
    ProductMediaComponent,
    ProductSoftwareComponent,
    FaqComponent,
    SearchComponent,
    UserProfileComponent,
    TicketComponent,
    LocalizedTextPipe,
    BlockCopyPasteDirective,
    ArticleComponent,
    ProductKBComponent,
    ProductVideosComponent,
    DeleteAccountComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,

    // i18n support
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient] // FIXME: required origin detection
      }
    }),

    AppRoutingModule,
    NgcCookieConsentModule.forRoot(cookieConfig),
    MatomoModule
  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: LOCALE_ID, useValue: 'it' },
    DefaultUrlSerializer,
    { provide: UrlSerializer, useClass: SearchQuerySerializer },
    TranslateModule,
    RoutingStateService,
    ErrorNotificationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
